import styles from "./ProgressBar.module.scss";

interface ProgressBarProps {
  progress: number; // 0-100
  label?: string;
  showPercentage?: boolean;
}

const ProgressBar = ({
  progress,
  label,
  showPercentage = true,
}: ProgressBarProps) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={styles.container}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.progressBar}>
        <div
          className={styles.progressBarFill}
          style={{ width: `${clampedProgress}%` }}
        >
          {showPercentage && (
            <span className={styles.percentage}>{Math.round(clampedProgress)}%</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;

